import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  selectIsAuthenticated,
  selectUserRole,
  selectAuthLoading,
} from "../features/auth/authSlice";
import PageLoader from "./PageLoader";

export default function ProviderRoute({ children }) {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const userRole = useSelector(selectUserRole);
  const loading = useSelector(selectAuthLoading);
  const location = useLocation();

  if (loading) {
    return <PageLoader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // If homeowner tries to access provider-only routes, send to upgrade page
  if (userRole !== "service_provider") {
    return <Navigate to="/upgrade" replace />;
  }

  return children;
}
